import { render } from "./download.vue?vue&type=template&id=1ab8f18a&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=1ab8f18a&lang=scss"
import "./download.vue?vue&type=style&index=1&id=1ab8f18a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab8f18a"]])

export default __exports__